import {
    collection,
    CollectionReference,
    DocumentData,
    Timestamp,
    getCountFromServer,
    doc,
    addDoc,
    updateDoc,
    deleteDoc,
    getDocs,
    getDoc,
    query,
    orderBy,
    limit,
    where,
    increment,
    arrayUnion
} from "firebase/firestore";
import { fs } from "../firebase.ts";
import { getDeviceID } from "../components/global.ts";

export interface Diamond {
    id?: string; // doc id => b.333.eco/d/id
    uid: string; // user id of creator
    date: Timestamp;

    ad: string; // optional announcement
    thumbnail: string; // thumbnail url: default = b logo // audio = ""
    src: string; // source url
    url: string; // optional redirect url: default = create your own!
    size: number; // file size in bytes
    type: "video" | "image" | "audio"; // file type

    // stats: from here
    digs?: number; // total digs
    diggers?: string[]; // device id of diggers
    miners?: string[]; // uid of miners

    // stats: b app
    previews?: number;
    crawlers?: Array<string>;
    scans?: number; // total scans
    scanners?: string[]; // device id of scanners
}

export class Diamonds {
    private collection: CollectionReference<DocumentData>;

    constructor() {
        this.collection = collection(fs, "diamonds");
    }

    async count(uid: string): Promise<number> {
        const q = query(this.collection, where("uid", "==", uid));
        const snapshot = await getCountFromServer(q);
        return snapshot.data().count;
    }

    async create(
        uid: string,
        ad: string,
        thumbnail: string,
        src: string,
        url: string,
        size: number,
        type: Diamond["type"]
    ): Promise<Diamond> {
        const diamond: Diamond = {
            date: Timestamp.now(),
            uid,
            ad,
            thumbnail,
            src,
            url,
            size,
            type
        };
        const docRef = await addDoc(this.collection, diamond);

        return {
            id: docRef.id,
            ...diamond
        };
    }

    async editAd(id: string, ad: string): Promise<string> {
        const docRef = doc(fs, "diamonds", id);
        await updateDoc(docRef, {
            ad
        });
        return ad;
    }

    async editUrl(id: string, url: string): Promise<string> {
        const docRef = doc(fs, "diamonds", id);
        await updateDoc(docRef, {
            url
        });
        return url;
    }

    async remove(id: string) {
        const docRef = doc(fs, "diamonds", id);
        await deleteDoc(docRef);
    }

    async get(id: string): Promise<Diamond | null> {
        const diamond = await getDoc(doc(fs, "diamonds", id));
        return diamond.exists()
            ? ({ id: diamond.id, ...diamond.data() } as Diamond)
            : null;
    }

    async getAll(uid: string): Promise<Diamond[]> {
        const q = query(
            this.collection,
            where("uid", "==", uid),
            orderBy("date", "desc") // or asc
            //limit(100)
        );
        const result = await getDocs(q);

        const diamonds: Diamond[] = [];
        result.docs.forEach((doc, index) => {
            const diamond = doc.data() as Diamond;
            diamonds.push({
                id: doc.id,
                ...diamond
            } as Diamond);
        });

        return diamonds; //.reverse();
    }

    // anyone
    async addMiner(uid: string, id: string) {
        const docRef = doc(fs, "diamonds", id);
        uid
            ? await updateDoc(docRef, {
                  digs: increment(1),
                  miners: arrayUnion(uid)
              })
            : await updateDoc(docRef, {
                  digs: increment(1),
                  diggers: arrayUnion(getDeviceID())
              });
    }
}
